import React from 'react';
import {
    Switch, Select, Divider, Input, Col, Row, Modal, Button, Form, Table, TreeSelect, Space, Tabs, Collapse,
    Tag,
    Badge,
    Tooltip
} from 'antd';
import { connect } from 'react-redux';
import { requestServerPost, selectPage, requestNodeServerPost, requestServerGet, requestWarroomServerGet } from '../../actions';
import PlaylistTableView from '../views/PlaylistTableView';
import Column from 'antd/lib/table/Column';
import ActionButton from '../ActionButton';
import "./PlaylistSelectorPopup.css";
import PopupManager from '../../managers/PopupManager';
import DataHelper from '../../helpers/DataHelper';
import Colors from '../../config/Colors';
import { CloseOutlined, CheckOutlined, CrownTwoTone, MailOutlined, SearchOutlined } from '@ant-design/icons';
import PermissionManager from '../../managers/PermissionManager';
import { User, MailCheck, MailWarning } from 'lucide-react';
import UserManagementModal from './usermanagement/UserManagermentModal';
import ActivateEmailModal from './ActivateEmailModal';
import { THEME_PALLETE } from '../../Theme';

const { TabPane } = Tabs;
const { Panel } = Collapse;

const { Option } = Select;
const { SHOW_PARENT } = TreeSelect;
// const SCALE_TYPES = ["fill", "contain", "cover", "none", "scale-down"]
const SCALE_TYPES = ["fill", "contain", "cover", "none"]
const SCALE_TYPE_DESCRIPTIONS = ["Media is sized to fill the channel's boundary", "Media is scaled to maintain its aspect ratio while fitting within the channel's boundary", "Media is sized to maintain its aspect ratio while filling the channel's boundary. The media will be clipped to fit", "Media is not resized"]

const allowEdit = true;
const allowDelete = true;

const formItemLayout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
    colon: true
};



class UserManagementPopup extends React.Component {

    constructor(props) {
        super(props);
        this.state = { passwordModalVisible: false, toEditUser: null, userRawDatas: [], users: [], roles: [], subscriptionPlans: [], accessContents: [], SelectedAccessContentsValue: [], DefaultAccessContentsValue: [], modalVisible: false, activateEmailModalVisible: false, userToActivate: null, searchText: "" }
    }

    prepareUserAccessContents = async (rawAccessContent) => {

        if (!rawAccessContent) {
            return [];
        }

        console.log("prepareUserAccessContents " + rawAccessContent)
        const obj = await JSON.parse(rawAccessContent);

        var result = []
        obj.forEach(bData => {
            if (!("brances" in bData)) {
                const brand = this.state.accessContents.find(b => `${b.BrandID}` === `${bData.brandid}`);
                if (brand && "Branches" in brand)
                    bData.branches = brand.Branches.map(branch => branch.BranchID);
            }
            bData.branches.forEach(branchID => {
                result.push(`branch-${bData.brandid}-${branchID}`)
            })
        })
        return result;
    }
    getTableColumns = () => {

        const { userdata } = this.props;

        const editPermission = PermissionManager.checkPermission(PermissionManager.PERMISSION_KEY_USER, PermissionManager.PERMISSION_TYPE_EDIT);
        const deletePermission = PermissionManager.checkPermission(PermissionManager.PERMISSION_KEY_USER, PermissionManager.PERMISSION_TYPE_DELETE);


        return [
            {
                title: 'UserName',
                dataIndex: 'username',
                key: 'username',
                render: (text, record) => {
                    if (userdata.user && `${record.key}` === `${userdata.user.userid}`) {
                        return <Space><CrownTwoTone />{text}</Space>
                    }
                    else {
                        return text
                    }
                }

            },
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name'
            },
            {
                title: 'Role',
                dataIndex: 'role',
                key: 'role'
            },
            {
                title: 'Active',
                dataIndex: 'status',
                key: 'status',
                align: 'center',
                render: (text, record, index) => {
                    var color = Colors.red;
                    if (text > 0) {
                        color = Colors.green;
                    }

                    const editUserPermission = PermissionManager.checkPermission(PermissionManager.PERMISSION_KEY_USER, PermissionManager.PERMISSION_TYPE_EDIT);

                    if ((userdata && userdata.user) && (`${record.key}` === `${userdata.user.userid}`)) {
                        return editUserPermission ? <Switch
                            checkedChildren={<CheckOutlined />}
                            unCheckedChildren={<CloseOutlined />}
                            checked={text === 1}
                            disabled={true}
                            onChange={(value) => {

                                this.updateUserActiveStatus(record.key, (value ? 1 : 0)).then(newValue => {
                                    this.reloadUsers();
                                })
                            }}
                            style={{ backgroundColor: text === 1 ? Colors.green : Colors.red }}
                        /> : (text === 1 ? "Active" : "Inactive")
                    }



                    return <div style={{ display: "flex", width: "100%", height: "100%", alignItems: "center", justifyContent: "center" }}>
                        {/* <div style={{ width: "15px", height: "15px", backgroundColor: color, borderRadius: "7.5px" }}></div> */}
                        {editUserPermission ? <Switch
                            checkedChildren={<CheckOutlined />}
                            unCheckedChildren={<CloseOutlined />}
                            checked={text === 1}
                            onChange={(value) => {

                                this.updateUserActiveStatus(record.key, (value ? 1 : 0)).then(newValue => {
                                    this.reloadUsers();
                                })
                            }}
                            style={{ backgroundColor: text === 1 ? Colors.green : Colors.red }}
                        /> : (text === 1 ? "Active" : "Inactive")}
                    </div>
                }
            },
            {
                title: 'Action',
                key: 'action',
                align: 'center',
                render: (text, record) => {

                    const showEdit = (userdata && userdata.user && (`${record.key}` === `${userdata.user.userid}`)) ? true : editPermission;
                    return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "4px" }}>

                        {((userdata && userdata.user && `${record.key}` === `${userdata.user.userid}`) || !deletePermission) ? null : (<ActionButton danger={true} visible={allowEdit} confirmText="Are you sure you want to delete this user?" onClicked={() => {
                            this.deleteUser(record)
                        }} title="Delete" showTitle={false} icon="/cms/assets/svgs/icons/trash_icon.svg"></ActionButton>)}

                        {(!showEdit) ? null : (<ActionButton onClicked={() => {
                            const user = this.getUserByID(record.key);
                            var selectedAccessContentsValue = this.state.defaultAccessContent;
                            if (user) {
                                console.log("user.accesscontent " + JSON.stringify(user.accesscontent))
                                selectedAccessContentsValue = this.prepareUserAccessContents(user.accesscontent)
                            }
                            this.setState({ toEditUser: user, modalVisible: true, SelectedAccessContentsValue: selectedAccessContentsValue })
                        }} visible={allowDelete} title="Edit" showTitle={false} icon="/cms/assets/svgs/icons/edit_icon.svg"></ActionButton>
                        )}

                        {
                            (!showEdit) ? null : (() => {
                                const user = this.getUserByID(record.key);
                                if (!user) return null;

                                if (user.isguest == 1 || !user.email) {
                                    return showEdit ? (
                                        <ActionButton
                                            onClicked={() => {
                                                this.setState({ userToActivate: user, activateEmailModalVisible: true });
                                            }}
                                            visible={true}
                                            title="Activate Email"
                                            showTitle={false}
                                            icon={<MailWarning className="action-btn-pulse" size={18} />}
                                        />
                                    ) : null;
                                } else {
                                    // Email activated
                                    return (
                                        <Tooltip title="Email Activated">
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "32px", height: "32px", margin: "2px" }}>
                                                <MailCheck size={18} color={Colors.green} />
                                            </div>
                                        </Tooltip>
                                    )
                                }
                            })()
                        }

                    </div>
                },
            },
        ];
    }

    componentDidMount() {
        const { } = this.props;
        this.reloadUsers().then(this.reloadUserRoles).then(this.reloadSubscriptionPlans).then(this.reloadAccessContents).then(this.prepareAccessContents)
        // this.setState({ selectedScale: mediaData.Scale });
        // this.reloadPlaylists();
    }

    deleteUser = (userData) => {
        const userID = userData.key

        return new Promise((resolve, reject) => {
            const { usermaintoken, requestServerPost, selectedBrandData } = this.props;

            requestServerPost("delete_user", { userid: userID }, null, (response) => {
                Modal.success({ content: `Successfully deleted ${userData.username}` })
                this.reloadUsers();
            }, usermaintoken)
        })
    }

    getRolesView = (rawRoles) => {
        if (!rawRoles)
            return "";

        if (rawRoles.length === 0)
            return "";

        //render first role as tag and if more that 1 role, show +x more with tooltip
        if (rawRoles.length === 1) {
            return <Tag>{rawRoles[0].rolename}</Tag>
        }
        if (rawRoles.length > 1) {
            const firstRole = rawRoles[0];
            const restRoles = rawRoles.slice(1);

            return (
                <div style={{ display: "flex", gap: 8 }}>
                    <Tag >{firstRole.rolename}</Tag>
                    {restRoles.length > 0 && (
                        <Tooltip title={restRoles.map(r => r.rolename).join(", ")}>
                            <Tag color="blue">+{restRoles.length} more</Tag>
                        </Tooltip>
                    )}
                </div>
            );
            // return <span><Badge count={rawRoles.length - 1} ><Tag>{rawRoles[0].rolename}</Tag></Badge></span>
        }
        return "";
    }

    reloadUsers = () => {
        return new Promise((resolve, reject) => {
            const { usermaintoken, requestServerGet, selectedBrandData } = this.props;

            requestServerGet("get_users", {}, null, (response) => {
                console.log(response.data)
                // const options = response.data.map(data => {
                //     return { value: data.CampaignID, label: data.CampaignName }
                // })

                const processedUsers = response.data.map((userData, index) => {
                    return {
                        key: userData.userid,
                        username: userData.username,
                        name: `${userData.firstname} ${userData.lastname}`,
                        role: this.getRolesView(userData.roles),
                        status: userData.activated,
                    }
                })
                // options.unshift({ value: 0, label: "Create New Playlist" })
                this.setState({ userRawDatas: response.data, users: processedUsers }, resolve)
                // this.setState({ campaigntDatas: options, campaignOptions: options })
            }, usermaintoken)
        })
    }


    reloadSubscriptionPlans = () => {
        return new Promise((resolve, reject) => {
            const { usertoken, requestWarroomServerGet, selectedBrandData } = this.props;

            requestWarroomServerGet("get_subscriptionplans", {}, null, (response) => {

                if (!response) {
                    this.setState({ subscriptionPlans: [] }, resolve)
                    return;
                }

                const responseData = response.data;
                console.log("reloadSubscriptionPlans " + JSON.stringify(responseData.data))
                if (!responseData || !responseData.success) {
                    console.log("reloadSubscriptionPlans no responseData")
                    this.setState({ subscriptionPlans: [] }, resolve)
                    return;
                }

                if (!responseData.data || responseData.data.length === 0) {
                    console.log("reloadSubscriptionPlans no data")
                    this.setState({ subscriptionPlans: [] }, resolve)
                    return;
                }

                this.setState({ subscriptionPlans: responseData.data }, resolve)
                // const processedRoles = response.data.map((roleData, index) => {
                //     return {
                //         userroleid: roleData.userroleid,
                //         userrolename: roleData.userrolename,
                //         userrolepermissions: roleData.Permissions
                //     }
                // })

                // this.setState({ roles: processedRoles }, resolve)
                resolve();
            }, usertoken)
        })

    }

    reloadUserRoles = () => {
        return new Promise((resolve, reject) => {
            const { usermaintoken, requestServerGet, selectedBrandData } = this.props;

            requestServerGet("get_optionrole", {}, null, (response) => {
                // console.log(response.data)
                // const options = response.data.map(data => {
                //     return { value: data.CampaignID, label: data.CampaignName }
                // })

                const processedRoles = response.data.map((roleData, index) => {
                    return {
                        userroleid: roleData.userroleid,
                        userrolename: roleData.userrolename,
                        userrolepermissions: roleData.rolepermission
                        // key: userData.userid,
                        // name: `${userData.firstname} ${userData.lastname}`,
                        // role: userData.userrolename,
                        // status: userData.activated.toLocaleLowerCase() === "y" ? 1 : 0,
                    }
                })
                // options.unshift({ value: 0, label: "Create New Playlist" })
                this.setState({ roles: processedRoles }, resolve)
                // this.setState({ campaigntDatas: options, campaignOptions: options })
            }, usermaintoken)
        })

    }

    prepareAccessContents = () => {

        return new Promise((resolve, reject) => {
            var defaultAccessContent = []

            this.state.accessContents.forEach(accessContentData => {

                defaultAccessContent.push(`brand-${accessContentData.BrandID}`);

            })
            this.setState({ DefaultAccessContentsValue: defaultAccessContent, SelectedAccessContentsValue: defaultAccessContent }, resolve)
        })
    }

    getMappedAccessContents = () => {
        const options = this.state.accessContents.map(accessContentData => {


            const branchesData = accessContentData.Branches ? accessContentData.Branches.map(branchData => {
                return {
                    title: branchData.BranchName,
                    value: `branch-${accessContentData.BrandID}-${branchData.BranchID}`,
                    key: `branch-${accessContentData.BrandID}-${branchData.BranchID}`,
                }
            }) : []

            console.log(JSON.stringify(accessContentData))
            return {
                title: accessContentData.BrandName,
                value: `brand-${accessContentData.BrandID}`,
                key: `brand-${accessContentData.BrandID}`,
                children: branchesData
            }
        })

        return options
    }
    reloadAccessContents = () => {
        return new Promise((resolve, reject) => {
            const { usermaintoken, requestServerGet, selectedBrandData } = this.props;

            requestServerGet("get_accesscontent", {}, null, (response) => {
                // console.log(response.data)
                // const options = response.data.map(data => {
                //     return { value: data.CampaignID, label: data.CampaignName }
                // })

                const processedAccessContents = response.data.map((roleData, index) => {
                    return {
                        // userroleid: roleData.userroleid,
                        // userrolename: roleData.userrolename
                        // key: userData.userid,
                        // name: `${userData.firstname} ${userData.lastname}`,
                        // role: userData.userrolename,
                        // status: userData.activated.toLocaleLowerCase() === "y" ? 1 : 0,
                    }
                })
                // options.unshift({ value: 0, label: "Create New Playlist" })
                this.setState({ accessContents: response.data }, resolve)
                // this.setState({ campaigntDatas: options, campaignOptions: options })
            }, usermaintoken)
        })

    }

    renderUserList = () => {


        const { userdata } = this.props;
        // console.log("JSON.stringify(userData)")
        // console.log(JSON.stringify(userdata))


        const data = userdata.user
        // const ownerUser = {
        //     key: data.userid ?? "",
        //     username: data.username ?? "",
        //     name: `${data.firstname ?? ""} ${data.lastname ?? ""}`,
        //     role: data.role ?? "",
        //     status: "1",
        // }


        const createPermission = PermissionManager.checkPermission(PermissionManager.PERMISSION_KEY_USER, PermissionManager.PERMISSION_TYPE_CREATE);

        const filteredUsers = this.state.users.filter(user => {
            const search = this.state.searchText.toLowerCase();
            return (user.name && user.name.toLowerCase().includes(search)) ||
                (user.username && user.username.toLowerCase().includes(search));
        });

        return <div style={{ minHeight: "500px", padding: "40px" }}>
            <div style={{ fontSize: 34, fontWeight: 400, lineHeight: "40px", width: "100%", margin: "0 0 30px 0" }}>
                User Management
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px", alignItems: "center" }}>
                <Input
                    placeholder="Search by name or username"
                    prefix={<SearchOutlined />}
                    onChange={e => this.setState({ searchText: e.target.value })}
                    style={{ width: 300 }}
                    allowClear
                />
                {createPermission ? <Button type="primary" onClick={this.launchCreateUser}>Create User</Button> : null}
            </div>

            <Table onHeaderRow={column => {
                return {
                    align: "center", // click header row
                };
            }} dataSource={filteredUsers} pagination={{ pageSize: 6 }} columns={this.getTableColumns()} />
        </div>
    }

    launchCreateUser = () => {
        this.setState({ modalVisible: true, toEditUser: null, SelectedAccessContentsValue: this.state.DefaultAccessContentsValue })
    }

    onSelectedAccessContentsChange = (changes) => {
        // console.log("changes " + changes)

        this.setState({ SelectedAccessContentsValue: changes })
    }

    createUser = (data) => {
        // console.log(JSON.stringify(data))

        //{"firstname":"Atis","lastname":"Sanguansat","username":"sikfreeze","password":"123","conofirm_password":"123","role":2,"accesscontents":["brand-1","brand-4","brand-5","brand-6","brand-9","brand-10","brand-19"]}

        const { requestServerPost, usermaintoken } = this.props;


        const params = new FormData();

        const { firstname, lastname, username, password, confirm_password, userroleid, accesscontent } = data
        var hash = {}
        accesscontent.forEach(selection => {
            const selectionArr = selection.split("-");
            switch (selectionArr[0]) {
                case "brand":
                    const brandid = selectionArr[1];
                    var branches = []
                    this.state.accessContents.forEach(brand => {
                        if (`${brand.BrandID}` === `${brandid}`) {
                            if ("Branches" in brand) {
                                branches = brand.Branches.map(branch => {
                                    return branch.BranchID
                                })
                            }
                        }
                    })

                    hash[brandid] = branches
                    break;
                case "branch":
                    const bbrandid = selectionArr[1];
                    const branchid = selectionArr[2];

                    if (!(bbrandid in hash && hash[bbrandid])) {
                        hash[bbrandid] = []
                    }
                    hash[bbrandid].push(branchid)
                    break;
            }

        })

        const processedAccessContents = Object.keys(hash).map(key => {
            return {
                brandid: key,
                branches: hash[key]
            }
        })
        params.append("firstname", firstname)
        params.append("lastname", lastname)
        params.append("username", username)
        params.append("password", password)
        params.append("userroleid", userroleid)
        params.append("accesscontent", JSON.stringify(processedAccessContents))
        params.append("activated", 1)


        requestServerPost("create_user", params, {}, (response) => {

            // console.log(JSON.stringify(response))

            this.setState({ modalVisible: false }, this.reloadUsers)

            // reloadTimelineSchedules();
        }, usermaintoken);
    }

    updateUserActiveStatus = (userid, newStatus) => {

        return new Promise((resolve, reject) => {
            const editPermission = PermissionManager.checkPermission(PermissionManager.PERMISSION_KEY_USER, PermissionManager.PERMISSION_TYPE_EDIT);

            if (!editPermission) {
                Modal.warning({ content: "You do have permission to edit this setting" });
                reject();
            }

            const { requestServerPost, usermaintoken } = this.props;


            const params = new FormData();

            var hash = {}

            params.append("userid", userid)
            params.append("activated", newStatus)


            requestServerPost("update_user", params, {}, (response) => {

                // console.log(JSON.stringify(response))
                resolve(newStatus)
            }, usermaintoken);
        }
        )
    }

    updateUser = (data) => {
        console.log(JSON.stringify(data))

        //{"firstname":"Atis","lastname":"Sanguansat","username":"sikfreeze","password":"123","conofirm_password":"123","role":2,"accesscontents":["brand-1","brand-4","brand-5","brand-6","brand-9","brand-10","brand-19"]}

        const { requestServerPost, usermaintoken } = this.props;


        const params = new FormData();

        const { firstname, lastname, username, password, confirm_password, userroleid, accesscontent } = data
        var hash = {}
        accesscontent.forEach(selection => {
            const selectionArr = selection.split("-");
            switch (selectionArr[0]) {
                case "brand":
                    const brandid = selectionArr[1];
                    var branches = []
                    this.state.accessContents.forEach(brand => {
                        if (`${brand.BrandID}` === `${brandid}`) {
                            if ("Branches" in brand) {
                                branches = brand.Branches.map(branch => {
                                    return branch.BranchID
                                })
                            }
                        }
                    })

                    hash[brandid] = branches
                    break;
                case "branch":
                    const bbrandid = selectionArr[1];
                    const branchid = selectionArr[2];

                    if (!(bbrandid in hash && hash[bbrandid])) {
                        hash[bbrandid] = []
                    }
                    hash[bbrandid].push(branchid)
                    break;
            }

        })

        const processedAccessContents = Object.keys(hash).map(key => {
            return {
                brandid: key,
                branches: hash[key]
            }
        })
        params.append("userid", this.state.toEditUser.key)
        params.append("firstname", firstname)
        params.append("lastname", lastname)
        params.append("username", username)
        if (password !== undefined)
            params.append("password", password)
        params.append("userroleid", userroleid)
        params.append("accesscontent", JSON.stringify(processedAccessContents))
        // params.append("activated", 1)


        requestServerPost("update_user", params, {}, (response) => {

            // console.log(JSON.stringify(response))

            this.setState({ modalVisible: false, toEditUser: null }, this.reloadUsers,)

            // reloadTimelineSchedules();
        }, usermaintoken);
    }

    onFormSubmit = (data) => {
        if (this.state.toEditUser) {
            this.updateUser(data)
        }
        else {
            this.createUser(data)
        }
    }

    getUserByID = (id) => {
        // console.log(JSON.stringify(this.state.userRawDatas))

        if (!this.state.userRawDatas)
            return null
        const user = this.state.userRawDatas.find(user => {
            return user.userid === id
        })

        return user;
    }

    getToEditUserData = () => {
        // console.log("this.state.toEditUser")
        // console.log(JSON.stringify(this.state.toEditUser))

        //  {"key":1,"username":"pcdx","name":"pcdx1234 ","role":"Administrator","status":0}

        if (this.state.toEditUser) {
            const user = this.getUserByID(this.state.toEditUser.key);

            if (!user) {
                return {}
            }
            else {
                // console.log(JSON.stringify(user))
                return {
                    firstname: user.firstname,
                    lastname: user.lastname,
                    username: user.username,
                    userroleid: user.userroleid
                }
            }
        }
        else {
            return {}
        }
    }

    render() {
        const { userdata } = this.props;
        const editPermission = PermissionManager.checkPermission(PermissionManager.PERMISSION_KEY_USER, PermissionManager.PERMISSION_TYPE_EDIT);
        const isOwnerUser = this.state.toEditUser ? (`${this.state.toEditUser.key}` === `${userdata.user.userid}`) : false

        const tData = this.getMappedAccessContents();
        const tProps = {
            allowClear: true,
            treeData: tData,
            value: this.state.SelectedAccessContentsValue,
            defaultValue: this.state.DefaultAccessContentsValue,
            onChange: this.onSelectedAccessContentsChange,
            treeCheckable: true,
            showCheckedStrategy: SHOW_PARENT,
            placeholder: 'Select brands/branches this user can access',
            style: {
                width: '100%'
            }
        };

        const validateMessages = {
            required: '${label} is required!',
            types: {
                email: 'Please enter a valid email!',
                number: '${label} is not a valid number!',
            }
        };

        const changePasswordModal = (
            <Modal key="modal"
                open={this.state.passwordModalVisible}
                footer={null}
                width={550}
                bodyStyle={{ padding: 0 }}
                onCancel={() => { this.setState({ passwordModalVisible: false }) }}
                destroyOnClose={true}

                afterClose={() => {

                    this.setState({ passwordModalVisible: false })
                }}
            >
                <Row style={{ width: "100%", height: "100%" }} justify="center">
                    <Col span={24} style={{ padding: "40px" }}>
                        <div style={{ fontSize: 38, fontWeight: 400, lineHeight: "42px", width: "100%", textAlign: "center", margin: "0 0 24px 0" }}>
                            Change Password
                        </div>
                        <Form
                            name="validate_other"
                            {...formItemLayout}
                            onFinish={this.onFormSubmit}
                            initialValues={{
                                accesscontent: this.state.SelectedAccessContentsValue,
                                ...this.getToEditUserData()

                            }}
                            validateMessages={validateMessages}
                        >
                            <Row style={{ width: "100%" }} justify="center">

                                <Col span={22} style={{ padding: "14px" }}>
                                    <Form.Item
                                        label="Current Password"
                                        name="oldpassword"
                                        rules={[{ required: true, message: "Please enter your current password!" }]}
                                    >
                                        <Input.Password autoComplete="new-password" placeholder="Password *" />
                                    </Form.Item>
                                    <Form.Item
                                        label="New Password"
                                        name="newpassword"
                                        rules={[{ required: true, message: "Please enter a new password!" }]}
                                    >
                                        <Input.Password autoComplete="new-password" placeholder="Password *" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Confirm Password"
                                        name="confirm_password"
                                        rules={[{ required: true, message: "Please re-enter the new password!" }]}
                                    >
                                        <Input.Password autoComplete="new-password" placeholder="Confirm Password *" />
                                    </Form.Item>


                                </Col>

                                <Col span={24}>
                                    <Form.Item wrapperCol={{ span: 12 }} justify="center" style={{ marginTop: "20px" }}>
                                        <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
                                            {this.state.toEditUser ? "Save" : "Create"}
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row >
            </Modal>
        )

        const onUserSaved = () => {
            this.reloadUsers();
        }

        const onUserClosed = () => {
            this.setState({ modalVisible: false, toEditUser: null })
        }

        return (

            <>{this.renderUserList()}
                <UserManagementModal parentProps={this.props} key={Math.random()} visible={this.state.modalVisible} roles={this.state.roles} accessContents={this.state.accessContents} subscriptionPlans={this.state.subscriptionPlans} onSave={onUserSaved} onClose={onUserClosed} selectedUserData={this.state.toEditUser}></UserManagementModal>
                {/* {createUserModal} */}
                {changePasswordModal}
                <ActivateEmailModal
                    visible={this.state.activateEmailModalVisible}
                    userData={this.state.userToActivate}
                    onCancel={() => this.setState({ activateEmailModalVisible: false, userToActivate: null })}
                    onSuccess={() => {
                        this.reloadUsers();
                    }}
                />
            </>

        )
    }
}

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, usermaintoken: state.usermaintoken, selectedBrandData: state.selectedBrandData, selectedBranchData: state.selectedBranchData };
}

export default connect(mapStateToProps, { requestServerGet, requestWarroomServerGet, requestServerPost, selectPage, requestNodeServerPost })(UserManagementPopup);